const normaliser = valeur => String(valeur || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()

export default {
    name: 'choix-prestations',
    props: {
        categories: { type: Array, default: () => [] },
        bilans: { type: Array, default: null },
        items: { type: Array, default: () => [] },
        value: { type: Array, default: () => [] },
        recherche: { type: String, default: '' },
        exigerPrix: { type: Boolean, default: false },
        // Champ du prix contrôlé par exigerPrix : 'prix' (normal) ou 'prix_urgence' (type de facturation urgence)
        champPrix: { type: String, default: 'prix' },
        titre: { type: String, default: 'Prestations' }
    },
    computed: {
        groupes() {
            const catalogue = new Map()
            this.categories.forEach(categorie => (categorie.analyses || []).forEach(item => catalogue.set(Number(item.id), item)))
            const categories = Array.isArray(this.bilans)
                ? this.bilans.map(bilan => ({
                    id: bilan.id,
                    nom: bilan.libelle,
                    examens: (bilan.examens || []).length,
                    analyses: (bilan.analyses || []).map(analyse => catalogue.get(Number(analyse.analyse_id))).filter(Boolean)
                }))
                : (this.categories.length ? this.categories : [{ id: 'tous', nom: this.titre, analyses: this.items }])
            const mots = normaliser(this.recherche).split(/\s+/).filter(Boolean)
            return categories.map(categorie => {
                const nom = categorie.nom || categorie.categorie || this.titre
                const source = Array.isArray(categorie.analyses) ? categorie.analyses : (categorie.items || [])
                const categorieCorrespond = mots.every(mot => normaliser(nom).includes(mot))
                const items = !mots.length || categorieCorrespond ? source : source.filter(item => mots.every(mot => normaliser(item.nom).includes(mot)))
                return { id: categorie.id, nom, items, examens: categorie.examens || 0 }
            }).filter(categorie => categorie.items.length || (Array.isArray(this.bilans) && mots.every(mot => normaliser(categorie.nom).includes(mot))))
        }
    },
    methods: {
        aUnPrix(item) { return Number(item[this.champPrix]) > 0 },
        estSelectionne(id) { return this.value.some(item => Number(item.id) === Number(id)) },
        estSelectionneDansGroupe(id, groupe) {
            if (!Array.isArray(this.bilans)) return this.estSelectionne(id)
            const item = this.value.find(acte => Number(acte.id) === Number(id))
            return Boolean(item && (item._origines || []).includes('bilan:' + groupe.id))
        },
        eligibles(groupe) { return groupe.items.filter(item => !this.exigerPrix || this.aUnPrix(item)) },
        categorieSelectionnee(groupe) {
            const eligibles = this.eligibles(groupe)
            if (Array.isArray(this.bilans)) {
                const origine = 'bilan:' + groupe.id
                return eligibles.length > 0 && eligibles.every(item => {
                    const choisi = this.value.find(acte => Number(acte.id) === Number(item.id))
                    return choisi && (choisi._origines || []).includes(origine)
                })
            }
            return eligibles.length > 0 && eligibles.every(item => this.estSelectionne(item.id))
        },
        basculerCategorie(groupe) {
            const eligibles = this.eligibles(groupe)
            if (!eligibles.length) return
            if (Array.isArray(this.bilans)) {
                const origine = 'bilan:' + groupe.id
                const retirer = this.categorieSelectionnee(groupe)
                const selection = this.value.map(item => ({ ...item, _origines: item._origines || ['individuel'] }))
                eligibles.forEach(analyse => {
                    const index = selection.findIndex(item => Number(item.id) === Number(analyse.id))
                    if (index < 0) {
                        if (!retirer) selection.push({ ...analyse, _origines: [origine] })
                        return
                    }
                    const origines = selection[index]._origines
                    selection[index]._origines = retirer ? origines.filter(source => source !== origine) : Array.from(new Set(origines.concat(origine)))
                })
                this.$emit('input', selection.filter(item => item._origines.length))
                return
            }
            const ids = new Set(eligibles.map(item => Number(item.id)))
            const selection = this.categorieSelectionnee(groupe)
                ? this.value.filter(item => !ids.has(Number(item.id)))
                : this.value.concat(eligibles.filter(item => !this.estSelectionne(item.id)))
            this.$emit('input', selection)
        },
        basculerItem(item, groupe) {
            if (this.exigerPrix && !this.aUnPrix(item)) {
                this.$emit('prix-manquant', item)
                return
            }
            if (Array.isArray(this.bilans)) {
                const origine = 'bilan:' + groupe.id
                const selection = this.value.map(acte => ({ ...acte, _origines: acte._origines || ['individuel'] }))
                const index = selection.findIndex(acte => Number(acte.id) === Number(item.id))
                if (index < 0) selection.push({ ...item, _origines: [origine] })
                else if (selection[index]._origines.includes(origine)) selection[index]._origines = selection[index]._origines.filter(source => source !== origine)
                else selection[index]._origines = selection[index]._origines.concat(origine)
                this.$emit('input', selection.filter(acte => acte._origines.length))
                return
            }
            const selection = this.estSelectionne(item.id)
                ? this.value.filter(acte => Number(acte.id) !== Number(item.id))
                : this.value.concat([{ ...item, _origines: ['individuel'] }])
            this.$emit('input', selection)
        }
    }
}
